// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y6k3YEcgkEWfjOtdaGh0{align-items:center;gap:8px;padding:10px 0;display:flex}.Qk3Qs6AT4U83mrDh0B3E{flex-direction:column;gap:4px;min-width:0;display:flex}.Cvn1UAIkL7QDpNsJQozR{margin-right:4px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"name": `y6k3YEcgkEWfjOtdaGh0`,
	"nameInfo": `Qk3Qs6AT4U83mrDh0B3E`,
	"inboxCellContainer": `Cvn1UAIkL7QDpNsJQozR`
};
export default ___CSS_LOADER_EXPORT___;
